import { render, staticRenderFns } from "./ProjectRegistration.info.vue?vue&type=template&id=359c875e&scoped=true"
import script from "./ProjectRegistration.info.vue?vue&type=script&lang=js"
export * from "./ProjectRegistration.info.vue?vue&type=script&lang=js"
import style0 from "./ProjectRegistration.info.vue?vue&type=style&index=0&id=359c875e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c875e",
  null
  
)

export default component.exports